//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var regNumber = /^[1-9]\d*$/;
export default {
    props: ['data', 'number'],
    watch: {
        number: function(newVal, oldVal) {
            this.$emit('update:number', newVal);
            this.$emit('change', this.data, newVal);
        }
    },
    methods: {
        plusNumber() {
            if (this.number >= this.data.stock) {
                this.$vux.toast.text('宝贝不能购买更多了哦');
            } else {
                this.number++;
            }
        },
        subNumber() {
            if (this.number <= 1) {
                this.$vux.toast.text('宝贝不能再减少了哦');
            } else {
                this.number--;
            }
        },
        inputNumber() {
            let that = this;
            that.$vux.confirm.prompt('请输入正整数', {
                title: that.data.goodsName + ' ' + that.data.versions,
                closeOnConfirm: false,
                onConfirm(value) {
                    if (!value || (value && !regNumber.test(value))) {
                        that.$vux.toast.text('请输入正整数');
                    } else {
                        that.number = value;
                        that.$vux.confirm.hide();
                    }
                },
                onShow() {
                    $('input').blur(function() {
                        that.$store.state.APPPAGE.blurFun();
                    });
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/common/checkNumber.vue